import { zodResolver } from '@hookform/resolvers/zod'
import { Modal } from 'antd'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'
import ModalWithButtons from '@/components/Atoms/ModalWithButtons/ModalWithButtons'
import { OptionType, SelectFormControlType } from '@/types'
import handleFormSubmitError from '@/utils/forms/handleFormSubmitError'

import {
  ALL_AVAILABLE_COLUMNS,
  columnCreationSchema,
  ColumnCreationType,
} from './ColumnCreationModal.config'

type ColumnCreationModalProps = {
  open: boolean
  columnsKeys: string[]
  setColumnsKeys: (columnsKeys: string[]) => void
  setOpen: (open: boolean) => void
}

function ColumnCreationModal(props: ColumnCreationModalProps) {
  const { open, columnsKeys, setColumnsKeys, setOpen } = props

  const [availableColumns, setAvailableColumns] = useState<OptionType[]>(() => {
    return ALL_AVAILABLE_COLUMNS.filter(
      (availableColumn) => !columnsKeys.includes(availableColumn.value)
    )
  })

  const [, contextHolder] = Modal.useModal()

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm<ColumnCreationType>({
    resolver: zodResolver(columnCreationSchema),
  })

  const handleAddColumn = (formData: ColumnCreationType) => {
    setColumnsKeys([
      ...columnsKeys.slice(0, columnsKeys.length - 1),
      formData.column.value,
      'removalAction',
    ])

    setAvailableColumns(
      availableColumns.filter(
        (availableColumn) =>
          availableColumn.value != formData.column.value &&
          availableColumn.label != formData.column.label
      )
    )

    setOpen(false)

    toast.success('Колонка добавлена', {
      description: formData.column.label,
    })

    reset()
  }

  return (
    <>
      {contextHolder}
      <ModalWithButtons
        title="Добавление колонки"
        open={open}
        onOk={async (e) => {
          e.stopPropagation()
          await handleSubmit(handleAddColumn, handleFormSubmitError(isValid))()
        }}
        onCancel={() => {
          setOpen(false)
          reset()
        }}
      >
        <form>
          <HoverElement>
            <AtomSelect
              title="Колонка:"
              formControl={control as SelectFormControlType}
              formName="column"
              options={availableColumns}
              openByHover={false}
              required
              formErrors={errors}
            />
          </HoverElement>
        </form>
      </ModalWithButtons>
    </>
  )
}

export default ColumnCreationModal
